import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SegmentList from '../../../common/SegmentList';
import segmentProps from '../../../common/SegmentCard/propTypes';
import { noop } from '../../../common/propTypes';
import { segmentsListRequested, setSelectedSegment } from '../actions';
import {
    getSegments,
    getSegmentsLoading,
    getRequestedSegmentsLimit,
    getChallenge,
} from '../selectors';

function ConnectedSegments({
    onLoad,
    segments,
    loading,
    updateSegmentId,
    requestedLimit,
    challenge,
    isResearcher,
}) {
    const [activeSegment, setActiveSegment] = useState(null);

    const handleActiveClass = (id) => {
        setActiveSegment(id);
    };

    useEffect(() => {
        if (challenge.id) onLoad(requestedLimit);
    }, [challenge]);

    useEffect(() => {
        if (segments && segments.length) {
            updateSegmentId(segments[0].id);
            handleActiveClass(segments[0].id);
        } else {
            updateSegmentId(null);
        }
    }, [segments]);

    return (
        <SegmentList
            activeSegment={activeSegment}
            segments={segments}
            loading={requestedLimit <= 10 && loading ? true : false}
            onSegmentSelect={(id) => {
                handleActiveClass(id);
                updateSegmentId(id);
            }}
            onLastItem={() => {
                if (isResearcher) {
                    onLoad(requestedLimit + 10);
                }
            }}
        />
    );
}

ConnectedSegments.propTypes = {
    challenge: PropTypes.object,
    // function to load segment list on component creation
    onLoad: PropTypes.func,
    // segments list to display in component
    segments: PropTypes.arrayOf(PropTypes.shape(segmentProps)),
    // function to call when segment in list is click
    fetchSegmentTags: PropTypes.func,
    // loading state of component
    loading: PropTypes.bool,
    // function to update segment id on select
    updateSegmentId: PropTypes.func,
    // number of segments requested via API
    requestedLimit: PropTypes.number,
    isResearcher: PropTypes.number,
};

ConnectedSegments.defaultProps = {
    onLoad: noop,
    segments: [],
    fetchSegmentTags: noop,
    updateSegmentId: noop,
    loading: false,
    requestedLimit: 10,
};

const mapStateToProps = (state) => {
    return {
        challenge: getChallenge(state),
        segments: getSegments(state),
        loading: getSegmentsLoading(state),
        requestedLimit: getRequestedSegmentsLimit(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: (limit) => dispatch(segmentsListRequested(limit)),
        updateSegmentId: (segmentId) => dispatch(setSelectedSegment(segmentId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedSegments);
